export default {
  title: 'Populære varer',
  list: {
    empty_list: {
      title: 'Ingen populære varer endnu.',
    },
    fields: {
      name: 'Navn',
      orders: 'Ordrer',
      sales: 'Salg',
    },
  },
};
